module.exports = __webpack_public_path__ + "img/back-arrow-left.4de41440.svg";